export const loadFromLocalStorage = (item, defaultValue = null) => {
    const data = localStorage.getItem(item);

    return data ? JSON.parse(data) : defaultValue;
};

export const setOnLocalStorage = (item, value) => {
    localStorage.setItem(item, JSON.stringify(value))
}